import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  const auditStatusArr = ["审核中", "审核通过", "审核不通过"];
  const AuditStatus = ({ props: { vo } }) => {
    const auditStatusName = auditStatusArr[vo.row.auditStatus];
    return <div domPropsInnerHTML={auditStatusName}></div>;
  };
  const toDetail = listeners["toDetail"] || function () { };

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    if (vo.row.myAuditStatus == 1) {
      dealConf.push([
        "icon-audit",
        "审核",
        () => {
          toDetail(vo.row, '审核');
        },
        "otherTrain:batchAudit"
      ]);
    } else {
      dealConf.push([
        "icon-audit-detail",
        "审核详情",
        () => {
          toDetail(vo.row, '审核详情');
        },
        "otherTrain:queryDeclare"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  function selectable(row, index) {
    if (row.myAuditStatus == 1) {
      return true
    }
    return false
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      selectable: selectable
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "90",
    }, {
      label: "工作单位",
      prop: "deptName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "培训名称",
      prop: "lectureName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "培训时间",
      prop: "trainTimeStr",
      minWidth: "140",
      // sortable: true
    },
    {
      label: "学时",
      prop: "lectureHours",
      minWidth: "80",
    },
    {
      label: "培训单位",
      prop: "organizer",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "培训地点",
      prop: "lecturePlace",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "我的审核状态",
      prop: "myAuditStatusStr",
      minWidth: "80",
    },
    {
      label: "申报审核状态",
      prop: "auditStatusStr",
      minWidth: "80",
      // render: vo => <AuditStatus vo={vo} />
    },
    {
      label: "申报时间",
      prop: "createDate",
      minWidth: "80"
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "60",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
